import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import ContentWrapper from "../generics/ContentWrapper.vue";
import CustomInputField from "../generics/CustomInputField.vue";
import SectionHeader from "../generics/SectionHeader.vue";
import CustomButton from "../generics/CustomButton.vue";
import { useAdminStore } from "@/store/adminStore";
import { reactive } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

const state = reactive({
  userName: "",
  password: "",
});

const adminStore = useAdminStore();

function handleUsernameInput(input: string) {
  state.userName = input;
}

function handlePasswordInput(input: string) {
  state.password = input;
}

function handleLogin() {
  adminStore.login(state.userName, state.password);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(ContentWrapper, null, {
      default: _withCtx(() => [
        _createVNode(SectionHeader, null, {
          default: _withCtx(() => [
            _createTextVNode("Login")
          ]),
          _: 1
        }),
        _createVNode(CustomInputField, {
          id: "login-username",
          class: "input-field",
          label: "Användarnamn",
          onOnInput: handleUsernameInput
        }),
        _createVNode(CustomInputField, {
          id: "login-password",
          class: "input-field",
          label: "Lösenord",
          onOnInput: handlePasswordInput
        }),
        _createVNode(CustomButton, { onOnClick: handleLogin }, {
          default: _withCtx(() => [
            _createTextVNode("Logga in")
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})